import styled from 'styled-components';
export const MessageActionsContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}px;
  width: fit-content;
  margin-top: ${({ theme }) => theme.spacing.sm}px;
  opacity: 0.7;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
`;
export const MessageActionsGroup = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md}px;
  width: fit-content;
`;
export const MessageFeedbackButtons = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: fit-content;
`;
